import { LandingJobRequestDetail } from "./LandingJobRequestDetail";
import { OpenJobs } from "./OpenJobs";

export const pages = {
  "public-job-requests": OpenJobs,
  "public-job-requests.detail": LandingJobRequestDetail,
};
